module.exports = __webpack_public_path__ + "img/glueMachinery.07d77787.jpg";